import React from "react";
import { Avatar } from "primereact/avatar";
import { Carousel } from "primereact/carousel";
import { FaQuoteLeft, FaStar } from "react-icons/fa";

import "./TestimonialSlider.css";

import A3Teach1 from "../images/a3-4.png";
import Wylth2 from "../images/wylth.png";
import Cigniti from "../images/Cigniti.png";
import Natinoal from "../images/Natinoal.png";
import DvritTech from "../images/DVRITTechLogoNoBG.png";
import AVCS from "../images/AVCSImage.png"
import Kidschoice from "../images/KidsChoiceImage.png"

const logoImages = [
  A3Teach1,
  Wylth2,
  Cigniti,
  Natinoal,
  DvritTech,
  AVCS,
  Kidschoice,
];

const testimonials = [
  {
    name: "Siddhesh Sawant",
    title: "Head of Wylth",
    // image: "https://randomuser.me/api/portraits/men/32.jpg",
    image: Wylth2,
    rating: 5,
    content:
      "We began working with Clota Technologies since Feb 2022. Fantastic Database Support Partner, Trustworthy, highly skilled and experienced team members. I sleep better knowing Clota has got our backs 24/7/365.",
  },
  {
    name: "Cignity – Database Support Services",
    title: "Head of Infrastructure, Cignity",
    // image: "https://randomuser.me/api/portraits/women/65.jpg",
    image: Cigniti,
    rating: 5,
    content:
      "Working with Clota Technology has been a game-changer for our database management. Their team ensured high availability, optimized performance, and seamless support across our environments. They are reliable partners in every sense.",
  },
  {
    name: "National Commerce Bank – Database Support Services",
    title: "IT Operations Manager, National Commerce Bank",
    // image: "https://randomuser.me/api/portraits/women/52.jpg",
    image: Natinoal,
    rating: 5,
    content:
      "Clota Technology has been instrumental in streamlining our database operations. Their proactive support, technical expertise, and quick response time have significantly improved our system reliability and performance. We truly appreciate their commitment and professionalism.",
  },
  {
    name: "DVR IT Technology – Web Development Services",
    title: "Project Lead, DVR IT Technology",
    // image: "https://randomuser.me/api/portraits/women/52.jpg",
    image: DvritTech,
    rating: 5,
    content:
      "Clota Technology exceeded our expectations in developing a highly functional and user-friendly website. Their ability to understand our technical requirements and turn them into a responsive platform was truly impressive.",
  },
  {
    name: "AV-CS – Web Development Services",
    title: "Managing Director, AV-CS",
    // image: "https://randomuser.me/api/portraits/women/52.jpg",
    image: AVCS,
    rating: 5,
    content:
      "Clota Technology delivered an excellent web solution tailored to our business needs. Their collaborative approach, innovative design, and attention to detail made the entire experience seamless. We’re extremely satisfied with the outcome.",
  },
  {
    name: "KidsChoice – E-commerce Website Development",
    title: "Founder, KidsChoice",
    // image: "https://randomuser.me/api/portraits/women/52.jpg",
    image: Kidschoice,
    rating: 5,
    content:
      "The team at Clota Technology did a fantastic job creating our KidsChoice e-commerce platform. The site is not only visually appealing but also highly optimized for performance and user experience. Their dedication to quality truly stands out.",
  },
];

const TestimonialSlider = () => {
  const responsiveOptions = [
    {
      breakpoint: "1024px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "768px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  const testimonialTemplate = (testimonial) => (
    <div className="testimonial-card surface-card p-4 border-round shadow-2">
      <FaQuoteLeft className="quote-icon" />
      <p className="testimonial-content mb-3">{testimonial.content}</p>
      <div className="flex align-items-center gap-3 mt-4">
        <Avatar
          image={testimonial.image}
          className="custom-avatar"
          // shape="circle"
        />
        <div>
          <strong className="name-text">{testimonial.name}</strong>
          <p className="m-0 title-text">{testimonial.title}</p>
        </div>
      </div>
      <div className="mt-3 flex">
        {Array.from({ length: testimonial.rating }).map((_, i) => (
          <FaStar key={i} className="mr-1" />
        ))}
      </div>
    </div>
  );

  return (
    <div className="testimonial-wrapper mt-5 px-5 py-2">
      {/* Scrolling Logos */}
      <div className="faded-logo-strip">
        {/* <h1
          className="text-center Text-Gradient font-bold mb-2"
          style={{ fontFamily: "rockwell" }}
        >
          <span className="text-primary">Our Partners</span>
        </h1> */}
                    <div
        className="text-center Text-Gradient"
        style={{ fontFamily: "rockwell" }}
      >
        <h1 className="">
          <b> Our Partners</b>
        </h1>
      </div>

        <div className="logo-scroll-track">
          {[...logoImages, ...logoImages].map((logo, i) => (
            <div className="logo-item-faded" key={i}>
              <img src={logo} alt={`logo-${i}`} />
            </div>
          ))}
        </div>
      </div>



      {/* Headings */}
      {/* <h1
        className="text-center Text-Gradient font-bold mb-2"
        style={{ fontFamily: "rockwell" }}
      >
        What <span className="text-primary">Our Clients</span> Say
      </h1> */}

            <div
        className="text-center Text-Gradient"
        style={{ fontFamily: "rockwell" }}
      >
        <h1>
          <b>What <span className="text-primary">Our Clients</span> Say</b>
        </h1>
      </div>

      <p className="text-center mb-5 text-sm md:text-base">
        Hear Directly Our Satisfied Partners
      </p>

      {/* Carousel */}
      <Carousel
        value={testimonials}
        numVisible={3}
        numScroll={1}
        circular
        autoplayInterval={30000}
        responsiveOptions={responsiveOptions}
        itemTemplate={testimonialTemplate}
        className="custom-carousel"
      />
    </div>
  );
};

export default TestimonialSlider;
